import type { Ref } from "react";
import { Button } from "../../ui";

/** The phone's top bar: the menu button that opens the sidebar drawer. From `md` the sidebar is always there. */
export function TopBar({
  menuOpen,
  onMenu,
  menuButtonRef,
}: {
  menuOpen: boolean;
  onMenu: () => void;
  menuButtonRef: Ref<HTMLButtonElement>;
}) {
  return (
    <header className="sticky top-0 z-20 flex h-12 items-center gap-3 border-b border-border bg-surface px-3 md:hidden">
      <Button ref={menuButtonRef} variant="ghost" aria-controls="sidebar" aria-expanded={menuOpen} onClick={onMenu}>
        <svg aria-hidden="true" viewBox="0 0 20 20" className="size-5" fill="currentColor">
          <path d="M3 5h14v2H3zM3 9h14v2H3zM3 13h14v2H3z" />
        </svg>
        <span className="sr-only">Open navigation</span>
      </Button>
      <p className="text-base font-semibold text-text">KitWork+</p>
    </header>
  );
}
